module.exports = require("xml-but-prettier");


//////////////////
// WEBPACK FOOTER
// external "xml-but-prettier"
// module id = 612
// module chunks = 0